import { StoreDevtoolsModule } from '@ngrx/store-devtools';

/**
 * Store devtools. Replaced by `index.prod.ts` in production builds, so no timeline ships.
 */
export const devToolModules = [
  StoreDevtoolsModule.instrument({
    name: 'Ninety',
    maxAge: 250,
  }),
];
